import React from 'react';
import { Box } from '@mui/material';

const poStages = [
  { stage: 'pending', label: 'Pending', count: 3, color: 'amber' },
  { stage: 'transit', label: 'In Transit', count: 2, color: 'blue' },
  { stage: 'delivered', label: 'Delivered', count: 4, color: 'green' },
  { stage: 'cancelled', label: 'Cancelled', count: 1, color: 'red' },
];

export default function POStatusCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">PO Status</h3>
        <span className="click-tag">Click rows for details</span>
      </div>
      <div id="vendPOStatus" className="funnel" style={{ height: '220px' }}>
        {poStages.map((stage) => (
          <Box
            key={stage.stage}
            className="funnel-row"
            data-stage={stage.stage}
          >
            <div className="funnel-label">{stage.label}</div>
            <div className="funnel-bar-bg">
              <div className={`funnel-bar inline-style-${stage.color === 'amber' ? '30' : stage.color === 'blue' ? '15' : stage.color === 'green' ? '7' : '17'}`} style={{ width: `${(stage.count / 4) * 100}%` }}>
                {stage.count}
              </div>
            </div>
          </Box>
        ))}
      </div>
    </Box>
  );
}
